export const isFeatureFlagEnabled = (accountConfig, featureFlagEnabled) =>
    accountConfig?.[featureFlagEnabled] === 'true';
